import { z } from "zod";
export const createProblemSchema = z.object({
    label: z
        .string()
        .min(1)
        .max(4)
        .regex(/^[A-Z][A-Z0-9]*$/, "Use letras maiusculas, ex.: A, B, C"),
    title: z.string().min(1).max(200),
    statementMd: z.string().max(200_000).default(""),
    timeLimitMs: z.number().int().positive().max(60_000).default(1000),
    memoryLimitKb: z.number().int().positive().max(1_048_576).default(262_144),
    isVisible: z.boolean().default(false),
});
export const updateProblemSchema = createProblemSchema.partial().refine((v) => Object.keys(v).length > 0, { message: "Informe ao menos um campo para alterar" });
export const testCaseSchema = z.object({
    position: z.number().int().positive().max(100),
    stdin: z.string().max(1_000_000),
    expectedOutput: z.string().max(1_000_000),
    isSample: z.boolean().default(false),
});
export const updateTestCaseSchema = testCaseSchema.partial().extend({
    /** Exigido para alterar casos depois que o contest comecou. */
    confirm: z.boolean().optional(),
});
//# sourceMappingURL=problems.js.map